import Column5 from '../GalleryList/Column5';
import React, { useContext } from 'react';
import './OneFollowee.scss';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
import chroma from 'chroma-js';
import { alpha } from '../../utils/color';

interface IOneFollowee {
  src: string;
  name?: string;
  onClick: () => void;
  id?: string;
  faceurl?: string;
  person?: any;
  deleteMode?:boolean;
  onDelete?:()=>void;
}
const OneFollowee = function(props: IOneFollowee) {
  const {deleteMode, onDelete} = props;
  let { total_image = 0 } = props.person || {};
  const { mainColor, componentColor, h1Color } = useContext(ThemeContext);
  const defaultBgColor = chroma(h1Color).alpha(0.1).css();

  return (
    <div className="one-followee">
      {/*某些手机出现了如果不滑动就不显示的问题，所以这里就不lazy了*/}
      <Column5
        src={props.src}
        onClick={props.onClick}
        lazy={false}
        bgColor={defaultBgColor}
      >
        {typeof props.person != 'undefined' ? (
          <div className="one-followee-anchor">
            <ReactSVG
              src={require('../../svg/number-bg.svg')}
              className={'anchor-bg'}
              style={{ color: mainColor }}
            />
            <span
              style={{ position: 'relative', color: alpha(componentColor, 1) }}
            >
              {Math.min(99, total_image)}
            </span>
          </div>
        ) : null}
      </Column5>
      {deleteMode ? <ReactSVG
        className="one-followee-delete"
        src={require('../../svg/v2/one_delete.svg')}
        onClick={onDelete}
      /> : null}
      {props.name ? <div className="name">{props.name}</div> : null}
    </div>
  );
};

export default OneFollowee;
